export default "__VITE_ASSET__CDv7NKvv__"